export const MC_MISMATCH_DATA_REQUEST = "MC_MISMATCH_DATA_REQUEST";
export const MC_MISMATCH_DATA_SUCCESS = "MC_MISMATCH_DATA_SUCCESS";
export const MC_MISMATCH_DATA_FAILED = "MC_MISMATCH_DATA_FAILED";
